import { dropOrigem } from 'utils/drops';

const getOrigemTributariaFilterFields = () => [
  { name: 'id', label: 'ID', type: 'number' },
  { name: 'codigo', label: 'Código', type: 'number' },
  { name: 'descricao', label: 'Descrição' },
  {
    name: 'origem',
    label: 'Origem',
    type: 'select',
    options: dropOrigem,
    multiple: true,
    initial: true,
  },
];

export default getOrigemTributariaFilterFields;
